export interface ActionParticipant {
    participant:Participants
}

export interface Participants {
    id: number,
    displayName?: string,
    firstName?: string,
    lastName?: string,
    email?:string
}

/**
 * A participant's name as "First Last". Actionstep's display name is "Last, First", so people are rebuilt from their
 * first and last names; a participant with neither (a company, say) keeps its display name.
 */
export function formatClientName(participant: Participants): string {
    const fullName = [participant.firstName?.trim(), participant.lastName?.trim()].filter(part => !!part).join(' ');
    return fullName || participant.displayName?.trim() || '';
}

export interface Disbursements {
    description?: string,
    quantity?: string;
    unitPrice?: string;
    subTotal?: string;
    tax?: string;
    total?: string;
    vatCode?: string;
    incomeAccount?: string;
}
